BS.DOMReady(function() {
    if (window.innerWidth <= 768) {
		[].forEach.call(document.querySelectorAll("img.switch"), function(img) {
			img.src = img.src.replace("_pc", "_sp");
        });
    }
});
